/**
 * Presets for the UpperLowerBoundsComponent.
 *
 * The component is self-contained (it manages its own internal signals for
 * value and dp) and does not accept params as an input. These presets capture
 * representative initial states that can be used to document the widget or
 * seed its internal state via the study-notes editor.
 */

export interface UpperLowerBoundsPresetState {
  readonly value: number;
  readonly dp: number;
}

export const UPPER_LOWER_BOUNDS_DEFAULT: UpperLowerBoundsPresetState = {
  value: 2.6,
  dp: 1,
};

export const UPPER_LOWER_BOUNDS_INTEGER: UpperLowerBoundsPresetState = {
  value: 15,
  dp: 0,
};

export const UPPER_LOWER_BOUNDS_TWO_DP: UpperLowerBoundsPresetState = {
  value: 3.45,
  dp: 2,
};

export const UPPER_LOWER_BOUNDS_THREE_DP: UpperLowerBoundsPresetState = {
  value: 0.128,
  dp: 3,
};

export const UPPER_LOWER_BOUNDS_LARGE_VALUE: UpperLowerBoundsPresetState = {
  value: 47.8,
  dp: 1,
};

export const UPPER_LOWER_BOUNDS_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: UPPER_LOWER_BOUNDS_DEFAULT },
  integer: { params: UPPER_LOWER_BOUNDS_INTEGER },
  'two-dp': { params: UPPER_LOWER_BOUNDS_TWO_DP },
  'three-dp': { params: UPPER_LOWER_BOUNDS_THREE_DP },
  'large-value': { params: UPPER_LOWER_BOUNDS_LARGE_VALUE },
};
